import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomTabs from "components/ControlTab/ControlTab";
import ClickAbleCustomTabs from "components/CustomTabs/CustomTabs";
import {
  APPLICATION_SUB_TYPE_POST_PLEDGE,
  APPLICATION_SUB_TYPE_PRE_PLEDGE,
  fieldAgentTabsName,
  loanApplicationStatus,
} from "assets/properties/properties";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import brandTheme from "brandTheme/Theme";
import LoanDetailsIcon from "../../../../../../assets/img/Loan_Details.png";
import ApplicantIcon from "../../../../../../assets/img/Applicant.png";
import ReviewIcon from "../../../../../../assets/img/review.png";
import BankIcon from "../../../../../../assets/img/bank.png";
import NomineeIcon from "../../../../../../assets/img/nominee.png";
import DocumentIcon from "../../../../../../assets/img/Document_page.png";
import EsignIcon from "../../../../../../assets/img/Esign.png";
import ApprovalIcon from "../../../../../../assets/img/approval.png";
import DisbursalIcon from "../../../../../../assets/img/disbursal.png";
import SanctionIcon from "../../../../../../assets/img/sanctions.png";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Review from "../../Review";
import Ornamentv2 from "../../Ornamentv2/Ornamentv2";
import Applicant from "../../Applicant/Applicant";
import BankInformation from "../../BankInformation/BankInformation";
import Footer from "../../../../../../components/UpdateUi/Footer/Footer";

import Nominee from "../../Nominee";
import Document from "../../Document/Document";
import LenderDetails from "../../LenderDetails";
import PawanTicketDetails from "../../PawanTicketDetails";
import CollateralEvaluationDecision from "../CollateralEvaluationDecision";
import Decision from "../Decision";
import DisbursalDetails from "../../Disbursal/DisbursalDetails";
import SanctionLetter from "../../SanctionLetter/SanctionLetter";
import Esign from "../../Esign";
import SanctionLetterPartB from "../../SanctionLetterPartB/SanctionLetterPartB";
import ESignPartB from "../../ESignPartB/ESignPartB";
import BtKitLetter from "../../BtKitLetter";
import UploadedBtKit from "../../UploadedBtKit";
import Affidavite from "../../Affidavite";
import InsuranceEligibility from "../../InsuranceEligiblity/InsuranceEligiblity";
import InsuranceLetter from "../../InsuranceLetter/InsuranceLetter";
import InsuranceESign from "../../InsuranceEsign/InsuranceEsign";
import { Button } from "@material-ui/core";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import ToastModal from "views/components/ToastModal";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import Header from "components/UpdateUi/Header/Header";
import zIndex from "@material-ui/core/styles/zIndex";
import DiscrepancyDecisionApproval from "../DiscrepancyApproval/DiscrepancyDecisionApproval";
import { tabId } from "assets/properties/properties";
import { sortTabsByEnvOrder } from "utils/Utils";
import { normalizeTabOrderFlag } from "utils/Utils";
import DeviationMasterDecision from "../DeviationMaster/DeviationMasterDecision";
import PreSanctionDecision from "../PreSanctionApproval/PreSanctionDecision";
import CollateralDecision from "../CollateralApproval/CollateralDecision";
import { parseAndSetFlag } from "utils/Utils";
import CreditAssessment from "../../CreditAssessment/CreditAssessment";
import CreditAssessmentEsign from "../../CreditAssessment/CreditAssessmentEsign";
import FinancialAndFamilyDetails from "../../CreditAssement/FinancialAndFamilyDetails";
import { getEndpoint } from "utils/Utils";

const style = () => ({
  inputFieldContainer: {
    margin: "0 auto",
    maxWidth: "1400px",
  },
  removeMarginInput: {
    marginTop: "20px !important",
  },
  fieldContaienr: {
    margin: "2% 2% 0px 2%",
    maxWidth: "29.3%",
    "@media (max-width: 768px)": {
      maxWidth: "46%",
      margin: "5% 2% 0px 2%",
    },
    "@media (max-width: 600px)": {
      maxWidth: "100%",
    },
    "@media (max-width: 450px)": {
      margin: "10% 2% 0px 2%",
    },
  },
  fieldContaienrReview: {
    margin: "2% 2% 0px 2%",
    maxWidth: "29.3%",
    "@media (max-width: 768px)": {
      maxWidth: "46%",
      margin: "5% 2% 0px 2%",
    },
    "@media (max-width: 600px)": {
      maxWidth: "100%",
    },
    "@media (max-width: 450px)": {
      margin: "2% 2% 0px 2%",
    },
  },
  header: {
    fontSize: brandTheme.headerFontSize,
    fontWeight: 700,
    lineHeight: "1.5rem",
    fontFamily: brandTheme.font.poppins,
    margin: "2% 2% 0px 2%",
  },
  inputContainer: {},
  label: {
    fontSize: "1.2rem",
    marginLeft: ".3rem",
    marginTop: "1.1rem",
    color: brandTheme.labelColor,
    "&:focus,&:visited,&": {
      position: "absolute",
      fontSize: ".7rem",
      color: brandTheme.black,
      marginTop: "-0.4rem",
      zIndex: "1",
      background: "white",
    },
  },
  nextButton: {
    boxShadow: "inherit",
    color: brandTheme.white,
    margin: "10px 10px 10px 0 ",
    letterSpacing: "1px",
    height: "40px",
    // width:"8%",
    padding: "0px 40px",
    width: "100px",
    backgroundColor: brandTheme.buttonColor,
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
      boxShadow: "inherit",
    },
    "&:focus": {
      backgroundColor: brandTheme.buttonHoverColor,
      boxShadow: "inherit",
    },
  },
  nextButton1: {
    boxShadow: "inherit",
    color: brandTheme.white,
    margin: "10px 10px 10px 0 ",
    padding: "0px 40px",
    height: "40px",
    // width:"8%",
    width: "100px",
    backgroundColor: brandTheme.button2Color,
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
      boxShadow: "inherit",
    },
    "&:focus": {
      backgroundColor: brandTheme.buttonHoverColor,
      boxShadow: "inherit",
    },
  },
  nextButton2: {
    boxShadow: "inherit",
    color: brandTheme.white,
    margin: "10px 10px 10px 0 ",
    padding: "0px 40px",
    height: "40px",
    // width:"8%",
    width: "150px",
    backgroundColor: brandTheme.button2Color,
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
      boxShadow: "inherit",
    },
    "&:focus": {
      backgroundColor: brandTheme.buttonHoverColor,
      boxShadow: "inherit",
    },
  },
  verifyButton: {
    position: "absolute",
    top: 0,
    right: 0,
    margin: 0,
  },
  nextButton3: {
    boxShadow: "inherit",
    color: brandTheme.white,
    padding: "0px 40px",
    height: "40px",
    width: "8%",
    backgroundColor: brandTheme.button2Color,
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
      boxShadow: "inherit",
    },
    "&:focus": {
      backgroundColor: brandTheme.buttonHoverColor,
      boxShadow: "inherit",
    },
  },
  cameraContainer: {
    width: "300px",
    height: "300px",
    padding: "0px !important",
    "& .react-html5-camera-photo > video": {
      width: " 300px !important",
      height: "300px !important",
      objectFit: "initial",
    },
    "& .react-html5-camera-photo > img": {
      width: " 300px !important",
      height: "300px !important",
      objectFit: "initial",
    },
  },
  imageWrapper: {
    width: "300px",
    height: "300px",
    position: "relative",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    "&:hover $image": {
      opacity: 0.5,
    },
    "&:hover $overlay": {
      opacity: 1,
    },
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.4)",
    color: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "1.5rem",
    fontWeight: "bold",
    opacity: 0,
    transition: "opacity 0.3s ease",
  },
  subLabel: {
    fontSize: brandTheme.textFontSize,
    fontWeight: 700,
    lineHeight: "1.5rem",
    display: "flex",
    alignItems: "center",
    paddingLeft: "4px",
    fontFamily: brandTheme.font.poppins,
    "@media (max-width: 600px)": {
      justifyContent: "center",
      padding: "0px",
      marginBottom: "15px",
      "&:first-child": {
        marginTop: "15px",
      },
    },
  },
  selectOptions: {
    marginBottom: "10px",
    "&:last-child": {
      marginBottom: "0px",
    },
  },
  button: {
    backgroundColor: brandTheme.buttonColor,
    color: brandTheme.white,
    borderRadius: "10px",
    padding: "10px 15px",
    minWidth: "140px",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
    },
  },
  buttonContainer: {
    position: "relative",
    justifyContent: "right",
    right: "9%",
    top: "3%",
    zIndex: 99,
    display: "flex",
  },
  checkboxInput: {
    width: 15,
    height: 15,
    marginRight: 15,
  },
});

const FieldAgentTabs = (props) => {
  const classes = props.classes;
  const {onReload, key, branchName, setBranchName} = props
  const featureFlags = props.featureFlags || {};
  const { loanApplicationId: paramLoanId } = useParams();
  const location = useLocation();
  const state = location.state || {};
  const navigate = useNavigate();
  const loanApplicationId = paramLoanId;
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [btKitEsign, setBtKitEsign]=useState(false)
   const [esignDisableBtKit, setEsignDisableBtKit] = useState(false);
   const [clickableTab, setClickableTab]=useState("")
   const collateralEvaluationName = featureFlags?.changeColleteralEvaluationTabName;
   const enabledV2InprocessTab = parseAndSetFlag(featureFlags?.enabledV2InprocessTab);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  useEffect(() => {
    if (paramLoanId) {
      getLoanApplicationId();
    }
  }, [paramLoanId]);
  const [totalCollateralValue, setTotalCollateralValue] = useState(0);
  const [loanApplicationNumber, setLoanApplicationNumber] = useState("");
  const [existingLoanOutstanding, setExistingLoanOutstanding] = useState(0);
  const [mobileNum, setMobileNum] = useState(state?.mobileNum || '');
  const [leadBranchCode, setLeadBranchCode] = useState("");
  const [loanAccountNumber, setLoanAccountNumber] = useState("");
  const status = state?.status || "";
  const subStatus = state?.subStatus || "";
  const prePledgeLoan = state?.prePledgeLoan || {};
  const loanType = state?.loanType || "";
  const seletedBranchCode = state?.seletedBranchCode || "";
  const loanApplicationNumbedisbusalDetails = state?.loanApplicationNumbedisbusalDetails || "";
  const enabledInsurance = state?.enabledInsurance || false;
  const customerProceedId = state?.customerProceedId || '';
  const prePledgeDisbursalDate = state?.prePledgeDisbursalDate || '';
  const initiatorType = state?.initiatorType || '';
  const level = state?.level || '';
  const mandatory = state?.mandatory || '';
  const deviation = state?.deviation || '';
  const collateralDescp = state?.collateralDescp || '';
  const newOrnaments = state?.newOrnaments;
  const deviationId = state?.deviationId;
  const collaterDiscId = state?.collaterDiscId;
  const deviationJson = state?.deviationJson;
  const existingLoanData = state?.existingLoanData;
  const customerName = state?.customerName;
  const actualLoanAmount = state?.actualLoanAmount;
  const prepledgeLoanMap = state?.prepledgeLoanMap;
  const prepledgeLoanData = state?.prepledgeLoanData || [];
  const disbursalAmount = state?.disbursalAmount;
  const version = state?.version;
  const productType = state?.productType;
  const [newOrnamentsToggle, setNewOrnamentsToggle] = useState(state?.newOrnaments);
  const getLoanApplicationId = async () => {
    try {
      setCallInProgress(true);
      const result = await apiHandler({
        url: `${endpoint.APPLICATION_SEARCH}loanApplicationId=${paramLoanId}`,
        authToken,
      });
      setCallInProgress(false);

      if (result?.data?.error_code) {
        toastUpdate("Error", result?.data?.user_description, true);
      } else {
        setTotalCollateralValue(result?.data?.totalCollateralValue || 0);
        setMobileNum(result?.data?.mobileNumber || "");
        setLeadBranchCode(result?.data?.branchCode || "");
        setLoanApplicationNumber(result?.data?.loanApplicationNumber || "");
        setLoanAccountNumber(result?.data?.loanAccountNumber || "");
        if(status === loanApplicationStatus?.disburseToLms || 
          status === loanApplicationStatus?.completed
         ){
          await getTotalLoanAmount(paramLoanId);
        }
      }
    } catch (error) {
      setCallInProgress(false);
      toastUpdate("Error", "Something went wrong while fetching data", true);
      console.error(error);
    }
  };
  const getTotalLoanAmount = async (custId) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url : endpoint.CREDIT_ASSESSMENT_DATA_FIND + paramLoanId ,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (!result?.data?.error_code) {
      setExistingLoanOutstanding(result?.data?.totalOutstandingAmount);
    }
  };
  const [currentTab, setCurrentTab] = useState(0);
  const [PanName, setPanName] = useState("");
  const [PanNumber, setPanNumber] = useState("");
  const [newCustomer, setNewCustomer] = useState(false);
  const [existdocumentLink, setExistDocumentLink] = useState([]);
  const [setDetailsss, getSetDetails] = useState("");
  const [isEsign, setIsEsign] = useState(false);
  const [isEsignB, setIsEsignB] = useState(false);
  const [alreadyEsigned, setAlreadyEsigned] = useState(false);
  const [isCreditEsign, setIsCreditEsign] = useState(false);
  const [alreadyCreditEsigned, setAlreadyCreditEsigned] = useState(false);
  const [alreadyEsignedB, setAlreadyEsignedB] = useState(false);
  const [esingDisable, setEsignDisable] = useState(false);
  const [esingCreditDisable, setEsignCreditDisable] = useState(false);
  const [crossSell, setCrossSell] = useState(false);
  const [alreadyEsignedInsurance, setAlreadyEsignedInsurance] = useState(false);
  const [isEsignInsurance, setIsEsignInsurance] = useState(false);
  const [esingInsuranceDisable, setEsignInsuranceDisable] = useState(false);
  const [esingDisablePartB, setEsignDisablePartB] = useState(false);
  const [firstTab, setFirstTab] = useState("");
  const updatePANInfo = (panObj) => {
    setPanName(panObj.nameOnPanCard);
    setPanNumber(panObj.panNumber);
  };

useEffect(() => {
  const order = normalizeTabOrderFlag(featureFlags?.tabOrderByStatus);
  if (order.length > 0) {
    setFirstTab(order[0]);
  }
}, [featureFlags?.tabOrderByStatus]);
const enableCreditAssesmentOnBtCases = subStatus !== APPLICATION_SUB_TYPE_PRE_PLEDGE || (parseAndSetFlag(featureFlags?.enabledCreditAssesmentInBtPrePledge) && subStatus === APPLICATION_SUB_TYPE_PRE_PLEDGE)
const getDynamicTabIndex = (baseIndex) => {
  let index = baseIndex;
  if (subStatus === APPLICATION_SUB_TYPE_PRE_PLEDGE) {
    index += 1;
  } else if (subStatus === APPLICATION_SUB_TYPE_POST_PLEDGE) {
    index += 2;
  }
  if (parseAndSetFlag(featureFlags?.creditAssessment) && enableCreditAssesmentOnBtCases) {
    index += 1;
  }
  return index;
};
  useEffect(() => {
    if(!firstTab) return; 
    // Set initial tab based on status
    switch (status) {
      case loanApplicationStatus?.collateralEvaluation:
      case loanApplicationStatus?.forApproval:
      case loanApplicationStatus?.preSanction:
      case loanApplicationStatus?.deviation:
      case loanApplicationStatus?.collateralApproval:
      case loanApplicationStatus?.discrepancy:
        setCurrentTab(getDynamicTabIndex(6))
        break;
      case loanApplicationStatus?.disbursal:
        setCurrentTab(getDynamicTabIndex(7))
        setClickableTab(getDynamicTabIndex(7))
        break;
      case loanApplicationStatus?.aadhaar:
        setCurrentTab((subStatus === APPLICATION_SUB_TYPE_PRE_PLEDGE || firstTab === tabId?.applicant) ? 0 : 1);
        break;
      case loanApplicationStatus?.selfie:
        setCurrentTab(getDynamicTabIndex(5));
        break;
      case loanApplicationStatus?.disburseToLms:
           setCurrentTab(getDynamicTabIndex(8))
        break;
      default:
        setCurrentTab(0);
        break;
    }
  }, [status, subStatus, loanApplicationId, firstTab]);

  const setNext = (setDetails) => {
    getSetDetails(setDetails);
    setCurrentTab(currentTab + 1);
  };

  const setBack = () => setCurrentTab(currentTab - 1);
  const onNewCustomer = (type) => setNewCustomer(type);
  const getOrnamentTab = (editable) => ({
    id: tabId?.ornament,
    tabName: fieldAgentTabsName?.loanDetails,
    icon: LoanDetailsIcon,
    tabContent: (
      <Ornamentv2
        totalCollateralValue={totalCollateralValue}
        classes={classes}
        status={status}
        loanApplicationId={loanApplicationId}
        loanApplicationNumber={loanApplicationNumber}
        updatePANInfo={updatePANInfo}
        setNext={setNext}
        setBack={setBack}
        editable={editable}
        prePledgeLoan={prePledgeLoan}
        seletedBranchCode={seletedBranchCode}
        loanType={loanType}
        mobileNum={mobileNum}
        setCrossSell={setCrossSell}
        subStatus={subStatus}
        leadBranchCode={leadBranchCode}
        featureFlags={featureFlags}
        newOrnaments={newOrnaments}
        newOrnamentsToggle={newOrnamentsToggle}
        setNewOrnamentsToggle={setNewOrnamentsToggle}
        firstTab={firstTab === tabId?.ornament}
        existingLoanData={existingLoanData}
        prepledgeLoanMap={prepledgeLoanMap}
        productType={productType}
      />
    ),
  });
  const getApplicantTab = (editable) => ({
    id: tabId?.applicant,
    tabName: fieldAgentTabsName?.applicant,
    icon: ApplicantIcon,
    tabContent: (
      <Applicant
        subStatus={subStatus}
        status={status}
        loanApplicationId={loanApplicationId}
        loanApplicationNumber={loanApplicationNumber}
        PanNameObj={PanName}
        PanNumberObj={PanNumber}
        onNewCustomer={onNewCustomer}
        documentLink={setExistDocumentLink}
        editable={editable}
        setNext={setNext}
        setBack={setBack}
        classes={classes}
        setDetailsss={setDetailsss}
        prePledgeLoan={prePledgeLoan}
        seletedBranchCode={seletedBranchCode}
        loanType={loanType}
        mobileNum={mobileNum}
        featureFlags={featureFlags}
        firstTab={firstTab === tabId?.applicant}
        existingLoanData={existingLoanData}
        loanAccountNumber={loanAccountNumber}
        actualLoanAmount={actualLoanAmount}
        prepledgeLoanMap={prepledgeLoanMap}
      />
    ),
  });
  const lenderDetailTab = (editable) => ({
    id: tabId?.lender,
    tabName: fieldAgentTabsName?.lenderDetails,
    icon: ApplicantIcon,
    tabContent: (
      <LenderDetails
        status={status}
        loanApplicationId={loanApplicationId}
        loanApplicationNumber={loanApplicationNumber}
        PanNameObj={PanName}
        PanNumberObj={PanNumber}
        onNewCustomer={onNewCustomer}
        documentLink={setExistDocumentLink}
        editable={editable}
        setNext={setNext}
        classes={classes}
        setBack={setBack}
        setDetailsss={setDetailsss}
        prePledgeLoan={prePledgeLoan}
        seletedBranchCode={seletedBranchCode}
        featureFlags={featureFlags}
        existingLoanData={existingLoanData}
      />
    ),
  });
  const pawanTicketDetailsTab = (editable) => ({
    id: tabId?.pawan,
    tabName: fieldAgentTabsName?.pawanTicketDetails,
    icon: ApplicantIcon,
    tabContent: (
      <PawanTicketDetails
        status={status}
        subStatus={subStatus}
        loanApplicationId={loanApplicationId}
        loanApplicationNumber={loanApplicationNumber}
        PanNameObj={PanName}
        PanNumberObj={PanNumber}
        onNewCustomer={onNewCustomer}
        documentLink={setExistDocumentLink}
        editable={editable}
        setNext={setNext}
        classes={classes}
        setBack={setBack}
        setDetailsss={setDetailsss}
        prePledgeLoan={prePledgeLoan}
        seletedBranchCode={seletedBranchCode}
        featureFlags={featureFlags}
        existingLoanData={existingLoanData}
      />
    ),
  });
  const reviewScreenTab = (editable) => ({
    id: tabId?.review,
    tabName: fieldAgentTabsName?.review,
    icon: ReviewIcon,
    tabContent: (
      <Review
        loanAccountNumber={loanAccountNumber}
        classes={classes}
        status={status}
        loanApplicationId={loanApplicationId}
        loanApplicationNumber={loanApplicationNumber}
        setNext={setNext}
        setBack={setBack}
        editable={editable}
        subStatus={subStatus}
        featureFlags={featureFlags}
        existingLoanData={existingLoanData}
      />
    ),
  });
    const familyScreen = (editable) => ({
    id: tabId?.creditAssessment,
    tabName: fieldAgentTabsName?.creditAssessment,
    icon: NomineeIcon,
    tabContent: (
      <FinancialAndFamilyDetails
        loanApplicationId={loanApplicationId}
        loanApplicationNumber={loanApplicationNumber}
        status={status}
        setNext={setNext}
        setBack={setBack}
        editable={editable}
        classes={classes}
        existingLoanData={existingLoanData}
        mobileNum={mobileNum}
        outletData={featureFlags}
        prepledgeLoanMap={prepledgeLoanMap}
        subStatus={subStatus}
        prePledgeLoan={prePledgeLoan}
      />
    ),
  });
  const bankDetailsScreen = (editable) => ({
    id: tabId?.bank,
    tabName: fieldAgentTabsName?.bankDetails,
    icon: BankIcon,
    tabContent: (
      <BankInformation
        status={status}
        loanApplicationId={loanApplicationId}
        loanApplicationNumber={loanApplicationNumber}
        setNext={setNext}
        setBack={setBack}
        editable={editable}
        classes={classes}
        prePledgeLoan={prePledgeLoan}
        seletedBranchCode={seletedBranchCode}
        subStatus={subStatus}
        loanType={loanType}
        mobileNum={mobileNum}
        crossSell={crossSell}
        featureFlags={featureFlags}
        existingLoanData={existingLoanData}
      />
    ),
  });
  const nomineeScreen = (editable) => ({
    id: tabId?.nominee,
    tabName: fieldAgentTabsName?.nomineeDetails,
    icon: NomineeIcon,
    tabContent: (
      <Nominee
        status={status}
        loanApplicationId={loanApplicationId}
        loanApplicationNumber={loanApplicationNumber}
        setNext={setNext}
        setBack={setBack}
        editable={editable}
        classes={classes}
        prePledgeLoan={prePledgeLoan}
        seletedBranchCode={seletedBranchCode}
        mobileNum={mobileNum}
        featureFlags={featureFlags}
        existingLoanData={existingLoanData}
      />
    ),
  });

  const documentScreen = (editable) => ({
    id: tabId?.document,
    tabName: fieldAgentTabsName?.document,
    icon: DocumentIcon,
    tabContent: (
      <Document
        subStatus={subStatus}
        classes={classes}
        status={status}
        loanApplicationId={loanApplicationId}
        loanApplicationNumber={loanApplicationNumber}
        newCustomer={newCustomer}
        setNext={setNext}
        setBack={setBack}
        existdocumentLink={existdocumentLink}
        editable={editable}
        prePledgeLoan={prePledgeLoan}
        seletedBranchCode={seletedBranchCode}
        loanType={loanType}
        mobileNum={mobileNum}
        featureFlags={featureFlags}
        newOrnamentsToggle={newOrnamentsToggle}
        existingLoanData={existingLoanData}
      />
    ),
  });

  const forApprovalScreen = (editable) => ({
    id: tabId?.forApproval,
    tabName: fieldAgentTabsName?.forApproval,
    icon: ApprovalIcon,
    tabContent: (
      <Decision
        subStatus={subStatus}
        classes={classes}
        status={status}
        loanApplicationId={loanApplicationId}
        loanApplicationNumber={loanApplicationNumber}
        setNext={setNext}
        setBack={setBack}
        editable={editable}
        prePledgeLoan={prePledgeLoan}
        seletedBranchCode={seletedBranchCode}
        featureFlags={featureFlags}
        existingLoanData={existingLoanData}
      />
    ),
  });
  const disbursalDetails = (editable)=>({
      id: tabId?.disbursal,
            tabName: fieldAgentTabsName?.disbursalDetails,
            icon: DisbursalIcon,
            tabContent: (
              <DisbursalDetails
                classes={classes}
                status={status}
                loanApplicationId={loanApplicationId}
                loanApplicationNumber={loanApplicationNumber}
                loanApplicationNumbedisbusalDetails={
                  loanApplicationNumbedisbusalDetails
                }
                subStatus={subStatus}
                setNext={setNext}
                setBack={setBack}
                editable={editable}
                showButton={true}
                customerProceedId={customerProceedId}
                loanAccountNumber={loanAccountNumber}
                prePledgeLoan={prePledgeLoan}
                seletedBranchCode={seletedBranchCode}
                prePledgeDisbursalDate={prePledgeDisbursalDate}
                loanType={loanType}
                initiatorType={initiatorType}
                leadBranchCode={leadBranchCode}
                featureFlags={featureFlags}
                actualLoanAmount={actualLoanAmount}
                prepledgeLoanMap={prepledgeLoanMap}
                mobileNum={mobileNum}
                prepledgeLoanData={prepledgeLoanData}
              />
            ),
  })
  const showFamilyDetailsTab = parseAndSetFlag(featureFlags?.creditAssessment) && enableCreditAssesmentOnBtCases;
  const getCurrentTabs = () => {
    let tabList = [];
    console.log
    switch (status) {
      case loanApplicationStatus?.inProcess:
      case loanApplicationStatus?.selfie:
      case loanApplicationStatus?.aadhaar:
        if (enabledV2InprocessTab) {
          const v1Tabs = [
            getApplicantTab(true),
            lenderDetailTab(true),
            pawanTicketDetailsTab(true),
            bankDetailsScreen(true),
            nomineeScreen(true),
          ];
          
          const v2Tabs = [
            getApplicantTab(false),
            getOrnamentTab(true),
            ...(showFamilyDetailsTab ? [familyScreen(true)] : []),
            reviewScreenTab(true),
            documentScreen(true),
          ];
          console.log(version === "V2" ? v2Tabs : v1Tabs,"tabList111",version === "V2")
          tabList = version === "V2" ? v2Tabs : v1Tabs;
        } else {
          tabList = [
            getOrnamentTab(true),
            getApplicantTab(true),
            lenderDetailTab(true),
            pawanTicketDetailsTab(true),
            ...(showFamilyDetailsTab ? [familyScreen(true)] : []),
            reviewScreenTab(true),
            bankDetailsScreen(true),
            nomineeScreen(true),
            documentScreen(true),
          ];
        }
      
        break;
      case loanApplicationStatus?.submitted:
        tabList = [
          getOrnamentTab(false),
          getApplicantTab(false),
          lenderDetailTab(false),
          pawanTicketDetailsTab(false),
          ...(showFamilyDetailsTab ? [familyScreen(false)] : []),
          reviewScreenTab(false),
          bankDetailsScreen(false),
          nomineeScreen(false),
          documentScreen(false),
        ];
        break;
      case loanApplicationStatus?.collateralEvaluation:
        tabList = [
          getOrnamentTab(false),
          getApplicantTab(false),
          lenderDetailTab(false),
          pawanTicketDetailsTab(false),
          ...(showFamilyDetailsTab ? [familyScreen(false)] : []),
          reviewScreenTab(false),
          bankDetailsScreen(false),
          nomineeScreen(false),
          documentScreen(false),
          {
            id: tabId?.collateralApproval,
            tabName: collateralEvaluationName,
            icon: ApprovalIcon,
            tabContent: (
              <CollateralEvaluationDecision
                subStatus={subStatus}
                classes={classes}
                status={status}
                loanApplicationId={loanApplicationId}
                loanApplicationNumber={loanApplicationNumber}
                setNext={setNext}
                setBack={setBack}
                editable={true}
                prePledgeLoan={prePledgeLoan}
                seletedBranchCode={seletedBranchCode}
                level={level}
                mandatory={mandatory}
                featureFlags={featureFlags}
              />
            ),
          },
        ];
        break;
        case loanApplicationStatus?.preSanction:
        tabList = [
          getOrnamentTab(false),
          getApplicantTab(false),
          lenderDetailTab(false),
          pawanTicketDetailsTab(false),
          ...(showFamilyDetailsTab ? [familyScreen(false)] : []),
          reviewScreenTab(false),
          bankDetailsScreen(false),
          nomineeScreen(false),
          documentScreen(false),
          {
            id: tabId?.preApproval,
            tabName: fieldAgentTabsName?.preApproval,
            icon: ApprovalIcon,
            tabContent: (
              <PreSanctionDecision
                subStatus={subStatus}
                classes={classes}
                status={status}
                loanApplicationId={loanApplicationId}
                loanApplicationNumber={loanApplicationNumber}
                setNext={setNext}
                setBack={setBack}
                editable={true}
                prePledgeLoan={prePledgeLoan}
                seletedBranchCode={seletedBranchCode}
                deviation={deviation}
                collateralDescp={collateralDescp}
                featureFlags={featureFlags}
                loanAccountNumber={loanAccountNumber}
                customerName={customerName}
              />
            ),
          },
        ];
        break;
        case loanApplicationStatus?.deviation:
        tabList = [
          getOrnamentTab(false),
          getApplicantTab(false),
          lenderDetailTab(false),
          pawanTicketDetailsTab(false),
          ...(showFamilyDetailsTab ? [familyScreen(false)] : []),
          reviewScreenTab(false),
          bankDetailsScreen(false),
          nomineeScreen(false),
          documentScreen(false),
          {
            id: tabId?.deviationApproval,
            tabName: fieldAgentTabsName?.deviationApproval,
            icon: ApprovalIcon,
            tabContent: (
              <DeviationMasterDecision
                subStatus={subStatus}
                classes={classes}
                status={status}
                loanApplicationId={loanApplicationId}
                loanApplicationNumber={loanApplicationNumber}
                setNext={setNext}
                setBack={setBack}
                editable={true}
                prePledgeLoan={prePledgeLoan}
                seletedBranchCode={seletedBranchCode}
                level={level}
                mandatory={mandatory}
                featureFlags={featureFlags}
                deviationId={deviationId}
                deviationJson={deviationJson}
              />
            ),
          },
        ];
        break;
        case loanApplicationStatus?.collateralApproval:
        tabList = [
          getOrnamentTab(false),
          getApplicantTab(false),
          lenderDetailTab(false),
          pawanTicketDetailsTab(false),
          ...(showFamilyDetailsTab ? [familyScreen(false)] : []),
          reviewScreenTab(false),
          bankDetailsScreen(false),
          nomineeScreen(false),
          documentScreen(false),
          {
            id: tabId?.collateralDicrepancyApproval,
            tabName: fieldAgentTabsName?.collateralDicrepancyApproval,
            icon: ApprovalIcon,
            tabContent: (
              <CollateralDecision
                subStatus={subStatus}
                classes={classes}
                status={status}
                loanApplicationId={loanApplicationId}
                loanApplicationNumber={loanApplicationNumber}
                setNext={setNext}
                setBack={setBack}
                editable={true}
                prePledgeLoan={prePledgeLoan}
                seletedBranchCode={seletedBranchCode}
                level={level}
                mandatory={mandatory}
                featureFlags={featureFlags}
                collaterDiscId={collaterDiscId}
              />
            ),
          },
        ];
        break;
      case loanApplicationStatus?.discrepancy:
        tabList = [
          getOrnamentTab(false),
          getApplicantTab(false),
          lenderDetailTab(false),
          pawanTicketDetailsTab(false),
          ...(showFamilyDetailsTab ? [familyScreen(false)] : []),
          reviewScreenTab(false),
          bankDetailsScreen(false),
          nomineeScreen(false),
          documentScreen(false),
          {
            id: tabId?.discrepancyApproval,
            tabName: fieldAgentTabsName?.forApproval,
            icon: ApprovalIcon,
            tabContent: (
              <DiscrepancyDecisionApproval
                subStatus={subStatus}
                classes={classes}
                status={status}
                loanApplicationId={loanApplicationId}
                loanApplicationNumber={loanApplicationNumber}
                setNext={setNext}
                setBack={setBack}
                editable={true}
                prePledgeLoan={prePledgeLoan}
                featureFlags={featureFlags}
                seletedBranchCode={seletedBranchCode}
              />
            ),
          },
        ];
        break;
      case loanApplicationStatus?.forApproval:
        tabList = [
          getOrnamentTab(false),
          getApplicantTab(false),
          lenderDetailTab(false),
          pawanTicketDetailsTab(false),
          ...(showFamilyDetailsTab ? [familyScreen(false)] : []),
          reviewScreenTab(false),
          bankDetailsScreen(false),
          nomineeScreen(false),
          documentScreen(false),
          forApprovalScreen(true)
        ];
        break;
      case loanApplicationStatus?.disbursal:
        tabList = [
          getOrnamentTab(false),
          getApplicantTab(false),
          lenderDetailTab(false),
          pawanTicketDetailsTab(false),
          ...(showFamilyDetailsTab ? [familyScreen(false)] : []),
          reviewScreenTab(false),
          bankDetailsScreen(false),
          nomineeScreen(false),
          documentScreen(false),
          forApprovalScreen(false),
          {
            id: tabId?.insurance,
            tabName: fieldAgentTabsName?.insuranceEligiblity,
            icon: SanctionIcon,
            tabContent: (
              <InsuranceEligibility
                classes={classes}
                status={status}
                loanApplicationId={loanApplicationId}
                loanApplicationNumber={loanApplicationNumber}
                setNext={setNext}
                setBack={setBack}
                editable={true}
                mobileNum={mobileNum}
                seletedBranchCode={seletedBranchCode}
                featureFlags={featureFlags}
                loanType={loanType}
                prePledgeLoan={prePledgeLoan}
              />
            ),
          },
          disbursalDetails(true)
        ];
        break;
      case loanApplicationStatus?.disburseToLms:
        tabList = [
          getOrnamentTab(false),
          getApplicantTab(false),
          lenderDetailTab(false),
          pawanTicketDetailsTab(false),
          ...(showFamilyDetailsTab ? [familyScreen(false)] : []),
          reviewScreenTab(false),
          bankDetailsScreen(false),
          nomineeScreen(false),
          documentScreen(false),
          forApprovalScreen(false),
          disbursalDetails(false),
          ...(parseAndSetFlag(featureFlags?.enableCreditAssesmentLetter) && ((Number(disbursalAmount) + Number(existingLoanOutstanding)) > Number(featureFlags?.creditAssessmentLetterAmountFlag)) && enableCreditAssesmentOnBtCases ? [
          {
            id: tabId?.sanctionLetterPartA,
            tabName: fieldAgentTabsName?.CreditAssessmentLetter,
            icon: SanctionIcon,
            tabContent: (
              <CreditAssessment
                classes={classes}
                status={status}
                loanApplicationId={loanApplicationId}
                loanApplicationNumber={loanApplicationNumber}
                setNext={setNext}
                setBack={setBack}
                editable={true}
                setIsEsign={setIsCreditEsign}
                isEsign={isCreditEsign}
                alreadyEsigned={alreadyCreditEsigned}
                setAlreadyEsigned={setAlreadyCreditEsigned}
                esingDisable={esingCreditDisable}
                setEsignDisable={setEsignCreditDisable}
                initiatorType={initiatorType}
                seletedBranchCode={seletedBranchCode}
                featureFlags={featureFlags}
                substatus={subStatus}
              />
            ),
          },
          {
            id: tabId?.CreditAssessmentEsign,
            tabName: fieldAgentTabsName?.CreditAssessmentEsign,
            icon: EsignIcon,
            tabContent: (
              <CreditAssessmentEsign
                classes={classes}
                status={status}
                loanApplicationId={loanApplicationId}
                loanApplicationNumber={loanApplicationNumber}
                setNext={setNext}
                setBack={setBack}
                editable={true}
                setIsEsign={setIsCreditEsign}
                isEsign={isCreditEsign}
                alreadyEsigned={alreadyCreditEsigned}
                setAlreadyEsigned={setAlreadyCreditEsigned}
                esingDisable={esingCreditDisable}
                setEsignDisable={setEsignCreditDisable}
                initiatorType={initiatorType}
                seletedBranchCode={seletedBranchCode}
                featureFlags={featureFlags}
                loanType={loanType}
                prePledgeLoan={prePledgeLoan}
              />
            ),
          },
        ]:[]),
          {
            id: tabId?.sanctionLetterPartA,
            tabName: fieldAgentTabsName?.sanctionLetterPartA,
            icon: SanctionIcon,
            tabContent: (
              <SanctionLetter
                classes={classes}
                status={status}
                loanApplicationId={loanApplicationId}
                loanApplicationNumber={loanApplicationNumber}
                setNext={setNext}
                setBack={setBack}
                editable={true}
                setIsEsign={setIsEsign}
                isEsign={isEsign}
                alreadyEsigned={alreadyEsigned}
                setAlreadyEsigned={setAlreadyEsigned}
                esingDisable={esingDisable}
                setEsignDisable={setEsignDisable}
                initiatorType={initiatorType}
                seletedBranchCode={seletedBranchCode}
                featureFlags={featureFlags}
              />
            ),
          },
          {
            id: tabId?.esignPartA,
            tabName: fieldAgentTabsName?.esignPartA,
            icon: EsignIcon,
            tabContent: (
              <Esign
                classes={classes}
                status={status}
                loanApplicationId={loanApplicationId}
                loanApplicationNumber={loanApplicationNumber}
                setNext={setNext}
                setBack={setBack}
                editable={true}
                setIsEsign={setIsEsign}
                isEsign={isEsign}
                alreadyEsigned={alreadyEsigned}
                setAlreadyEsigned={setAlreadyEsigned}
                esingDisable={esingDisable}
                setEsignDisable={setEsignDisable}
                initiatorType={initiatorType}
                seletedBranchCode={seletedBranchCode}
                featureFlags={featureFlags}
                loanType={loanType}
                prePledgeLoan={prePledgeLoan}
              />
            ),
          },
          {
            id: tabId?.sanctionLetterPartB,
            tabName: fieldAgentTabsName?.sanctionLetterPartB,
            icon: SanctionIcon,
            tabContent: (
              <SanctionLetterPartB
                classes={classes}
                status={status}
                loanApplicationId={loanApplicationId}
                loanApplicationNumber={loanApplicationNumber}
                setNext={setNext}
                setBack={setBack}
                editable={true}
                setIsEsign={setIsEsignB}
                isEsign={isEsignB}
                alreadyEsigned={alreadyEsignedB}
                setAlreadyEsigned={setAlreadyEsignedB}
                esingDisable={esingDisablePartB}
                setEsignDisable={setEsignDisablePartB}
                initiatorType={initiatorType}
                seletedBranchCode={seletedBranchCode}
                featureFlags={featureFlags}
              />
            ),
          },

          {
            id: tabId?.esignPartB,
            tabName: fieldAgentTabsName?.esignPartB,
            icon: EsignIcon,
            tabContent: (
              <ESignPartB
                classes={classes}
                status={status}
                loanApplicationId={loanApplicationId}
                loanApplicationNumber={loanApplicationNumber}
                setNext={setNext}
                setBack={setBack}
                editable={false}
                setIsEsign={setIsEsignB}
                isEsign={isEsignB}
                alreadyEsigned={alreadyEsignedB}
                setAlreadyEsigned={setAlreadyEsignedB}
                esingDisable={esingDisablePartB}
                setEsignDisable={setEsignDisablePartB}
                initiatorType={initiatorType}
                seletedBranchCode={seletedBranchCode}
                featureFlags={featureFlags}
                loanType={loanType}
                prePledgeLoan={prePledgeLoan}
              />
            ),
          },
          {
            id: tabId?.btKit,
            tabName: fieldAgentTabsName?.btKit,
            icon: SanctionIcon,
            tabContent: (
              <BtKitLetter
                classes={classes}
                status={status}
                loanApplicationId={loanApplicationId}
                loanApplicationNumber={loanApplicationNumber}
                setNext={setNext}
                setBack={setBack}
                editable={true}
                seletedBranchCode={seletedBranchCode}
                featureFlags={featureFlags}
                btKitEsign={btKitEsign}
                setBtKitEsign={setBtKitEsign}
                esignDisableBtKit={esignDisableBtKit}
                setEsignDisableBtKit={setEsignDisableBtKit}
                disbursalAmount={Number(disbursalAmount)}
              />
            ),
          },
          {
            id: tabId?.uploadKit,
            tabName: fieldAgentTabsName?.uploadKit,
            icon: EsignIcon,
            tabContent: (
              <UploadedBtKit
                classes={classes}
                status={status}
                loanApplicationId={loanApplicationId}
                loanApplicationNumber={loanApplicationNumber}
                setNext={setNext}
                setBack={setBack}
                editable={false}
                seletedBranchCode={seletedBranchCode}
                featureFlags={featureFlags}
                loanType={loanType}
                prePledgeLoan={prePledgeLoan}
                 btKitEsign={btKitEsign}
                setBtKitEsign={setBtKitEsign}
                esignDisableBtKit={esignDisableBtKit}
                setEsignDisableBtKit={setEsignDisableBtKit}
              />
            ),
          },
          {
            id: tabId?.affidavit,
            tabName: fieldAgentTabsName?.affidavit,
            icon: EsignIcon,
            tabContent: (
              <Affidavite
                classes={classes}
                status={status}
                loanApplicationId={loanApplicationId}
                loanApplicationNumber={loanApplicationNumber}
                setNext={setNext}
                setBack={setBack}
                editable={true}
                loanAccountNumber={loanAccountNumber}
                initiatorType={initiatorType}
                seletedBranchCode={seletedBranchCode}
                featureFlags={featureFlags}
                loanType={loanType}
                prePledgeLoan={prePledgeLoan}
              />
            ),
          },
          {
            id: tabId?.insuranceLetter,
            tabName: fieldAgentTabsName?.insuranceLetter,
            icon: SanctionIcon,
            tabContent: (
              <InsuranceLetter
                classes={classes}
                status={status}
                loanApplicationId={loanApplicationId}
                loanApplicationNumber={loanApplicationNumber}
                setNext={setNext}
                setBack={setBack}
                editable={true}
                setIsEsign={setIsEsignInsurance}
                isEsign={isEsignInsurance}
                esingDisable={esingInsuranceDisable}
                setEsignDisable={setEsignInsuranceDisable}
                seletedBranchCode={seletedBranchCode}
                featureFlags={featureFlags}
                loanType={loanType}
                prePledgeLoan={prePledgeLoan}
              />
            ),
          },
          {
            id: tabId?.insuranceEsign,
            tabName: fieldAgentTabsName?.insuranceEsign,
            icon: SanctionIcon,
            tabContent: (
              <InsuranceESign
                classes={classes}
                status={status}
                loanApplicationId={loanApplicationId}
                loanApplicationNumber={loanApplicationNumber}
                setNext={setNext}
                setBack={setBack}
                editable={false}
                setIsEsign={setIsEsignInsurance}
                isEsign={isEsignInsurance}
                alreadyEsigned={alreadyEsignedInsurance}
                setAlreadyEsigned={setAlreadyEsignedInsurance}
                esingDisable={esingInsuranceDisable}
                setEsignDisable={setEsignInsuranceDisable}
                seletedBranchCode={seletedBranchCode}
                featureFlags={featureFlags}
                loanType={loanType}
                prePledgeLoan={prePledgeLoan}
              />
            ),
          },
        ];
        break;
      case loanApplicationStatus?.completed:
        tabList = [
          getOrnamentTab(false),
          getApplicantTab(false),
          lenderDetailTab(false),
          pawanTicketDetailsTab(false),
          ...(showFamilyDetailsTab ? [familyScreen(false)] : []),
          reviewScreenTab(false),
          bankDetailsScreen(false),
          nomineeScreen(false),
          documentScreen(false),
          forApprovalScreen(false),
           {
            id: tabId?.affidavit,
            tabName: fieldAgentTabsName?.affidavit,
            icon: EsignIcon,
            tabContent: (
              <Affidavite
                classes={classes}
                status={status}
                loanApplicationId={loanApplicationId}
                loanApplicationNumber={loanApplicationNumber}
                setNext={setNext}
                setBack={setBack}
                editable={false}
                loanAccountNumber={loanAccountNumber}
                initiatorType={initiatorType}
                seletedBranchCode={seletedBranchCode}
                featureFlags={featureFlags}
                loanType={loanType}
                prePledgeLoan={prePledgeLoan}
              />
            ),
          },
          ...(parseAndSetFlag(featureFlags?.enableCreditAssesmentLetter) && ((Number(disbursalAmount) + Number(existingLoanOutstanding)) > Number(featureFlags?.creditAssessmentLetterAmountFlag)) && subStatus !== APPLICATION_SUB_TYPE_PRE_PLEDGE ? [
          {
            id: tabId?.CreditAssessmentEsign,
            tabName: fieldAgentTabsName?.CreditAssessmentEsign,
            icon: EsignIcon,
            tabContent: (
              <CreditAssessmentEsign
                classes={classes}
                status={status}
                loanApplicationId={loanApplicationId}
                loanApplicationNumber={loanApplicationNumber}
                setNext={setNext}
                setBack={setBack}
                editable={false}
                prePledgeLoan={prePledgeLoan}
                seletedBranchCode={seletedBranchCode}
                featureFlags={featureFlags}
                loanType={loanType}
              />
            ),
          },
        ]:[]),
          {
            id: tabId?.esignPartA,
            tabName: fieldAgentTabsName?.esignPartA,
            icon: EsignIcon,
            tabContent: (
              <Esign
                classes={classes}
                status={status}
                loanApplicationId={loanApplicationId}
                loanApplicationNumber={loanApplicationNumber}
                setNext={setNext}
                setBack={setBack}
                editable={false}
                prePledgeLoan={prePledgeLoan}
                seletedBranchCode={seletedBranchCode}
                featureFlags={featureFlags}
                loanType={loanType}
              />
            ),
          },
          {
            id: tabId?.esignPartB,
            tabName: fieldAgentTabsName?.esignPartB,
            icon: EsignIcon,
            tabContent: (
              <ESignPartB
                classes={classes}
                status={status}
                loanApplicationId={loanApplicationId}
                loanApplicationNumber={loanApplicationNumber}
                setNext={setNext}
                setBack={setBack}
                editable={false}
                prePledgeLoan={prePledgeLoan}
                seletedBranchCode={seletedBranchCode}
                featureFlags={featureFlags}
                loanType={loanType}
              />
            ),
          },
          {
            id: tabId?.uploadKit,
            tabName: fieldAgentTabsName?.uploadKit,
            icon: EsignIcon,
            tabContent: (
              <UploadedBtKit
                classes={classes}
                status={status}
                loanApplicationId={loanApplicationId}
                loanApplicationNumber={loanApplicationNumber}
                setNext={setNext}
                setBack={setBack}
                editable={false}
                seletedBranchCode={seletedBranchCode}
                featureFlags={featureFlags}
                loanType={loanType}
                prePledgeLoan={prePledgeLoan}
              />
            ),
          },
            disbursalDetails(false),
        ];
        break;
      case loanApplicationStatus?.rejected:
        tabList = [
           getOrnamentTab(false),
          getApplicantTab(false),
          lenderDetailTab(false),
          pawanTicketDetailsTab(false),
          ...(showFamilyDetailsTab ? [familyScreen(false)] : []),
          reviewScreenTab(false),
          bankDetailsScreen(false),
          nomineeScreen(false),
          documentScreen(false),
          forApprovalScreen(false),
          {
            id: tabId?.esignPartA,
            tabName: fieldAgentTabsName?.esignPartA,
            icon: EsignIcon,
            tabContent: (
              <Esign
                classes={classes}
                status={status}
                loanApplicationId={loanApplicationId}
                loanApplicationNumber={loanApplicationNumber}
                setNext={setNext}
                setBack={setBack}
                editable={false}
                prePledgeLoan={prePledgeLoan}
                seletedBranchCode={seletedBranchCode}
                featureFlags={featureFlags}
                loanType={loanType}
              />
            ),
          },
          {
            id: tabId?.esignPartB,
            tabName: fieldAgentTabsName?.esignPartB,
            icon: EsignIcon,
            tabContent: (
              <ESignPartB
                classes={classes}
                status={status}
                loanApplicationId={loanApplicationId}
                loanApplicationNumber={loanApplicationNumber}
                setNext={setNext}
                setBack={setBack}
                editable={false}
                prePledgeLoan={prePledgeLoan}
                seletedBranchCode={seletedBranchCode}
                featureFlags={featureFlags}
                loanType={loanType}
              />
            ),
          },
          {
            id: tabId?.uploadKit,
            tabName: fieldAgentTabsName?.uploadKit,
            icon: EsignIcon,
            tabContent: (
              <UploadedBtKit
                classes={classes}
                status={status}
                loanApplicationId={loanApplicationId}
                loanApplicationNumber={loanApplicationNumber}
                setNext={setNext}
                setBack={setBack}
                editable={false}
                seletedBranchCode={seletedBranchCode}
                featureFlags={featureFlags}
                loanType={loanType}
                prePledgeLoan={prePledgeLoan}
              />
            ),
          },
        ];
        break;
      default:
        break;
    }
    return sortTabsByEnvOrder(tabList, status, featureFlags);
  };

  const handleClose = () => {
    if (
      status === loanApplicationStatus?.inProcess ||
      status === loanApplicationStatus?.selfie ||
      status === loanApplicationStatus?.aadhaar
    ) {
      if (version === "V2") {
        navigate("/loanservice/inProcess/V2", { state: { from: "" } });
      }else{
        navigate("/loanservice/inProcess", { state: { from: "" } });
      }
    } else if(status === loanApplicationStatus?.submitted) {
      navigate("/loanservice/submitted", { state: { from: "" } });
    } else if(status === loanApplicationStatus?.forApproval) {
      navigate("/loanservice/approval", { state: { from: "" } });
    } else if(status === loanApplicationStatus?.collateralEvaluation) {
      navigate("/loanservice/collateralEvaluation", { state: { from: "" } });
    } else if(status === loanApplicationStatus?.disbursal) {
      navigate("/loanservice/disbursal", { state: { from: "" } });
    } else if(status === loanApplicationStatus?.disburseToLms) {
      navigate("/loanservice/disbursLms", { state: { from: "" } });
    } else if(status === loanApplicationStatus?.completed) {
      navigate("/loanservice/completed", { state: { from: "" } });
    }else if(status === loanApplicationStatus?.rejected) {
      navigate("/loanservice/rejected", { state: { from: "" } });
    } else if(status === loanApplicationStatus?.discrepancy) {
      navigate("/loanservice/discrepancyApproval", { state: { from: "" } });
    }else if(status === loanApplicationStatus?.preSanction) {
      navigate("/loanservice/preSanction", { state: { from: "" } });
    }else if(status === loanApplicationStatus?.deviation) {
      navigate("/loanservice/deviation", { state: { from: "" } });
    }else if(status === loanApplicationStatus?.collateralApproval) {
      navigate("/loanservice/collateralApproval", { state: { from: "" } });
    } else {
      console.log("Handle other status or just close modal");
    }
  };
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [showSidebar, setShowSidebar] = React.useState(true);
    const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleSidebarToggle = () => {
    setShowSidebar(!showSidebar);
  };
  const { userDetails } = useSelector((state) => state.userDetail.userDetails);
    if(!firstTab){
      return null
    }
  return (
    <GridContainer justify="center" style={{ position: "relative" }}>
      <Header
        handleDrawerToggle={handleDrawerToggle}
        handleSidebarToggle={handleSidebarToggle}
        userDetailsData={userDetails}
        onReload={onReload}
        key={key}
        branchName={branchName}
        setBranchName={setBranchName}
        outletData={featureFlags}
        hideDrawer
      />
      <GridItem xs={12} sm={12} md={12} lg={12}>
        {status === loanApplicationStatus?.inProcess ? (
          <CustomTabs
            headerColor="Gray"
            currentTab={currentTab}
            tabs={getCurrentTabs()}
            substatus={subStatus}
            status={status}
            enabledInsurance={enabledInsurance}
            fieldAgent
            handleClose={handleClose}
          />
        ) : (
          <ClickAbleCustomTabs
            headerColor="Gray"
            currentTab={currentTab}
            tabs={getCurrentTabs()}
            setCurrentTab={setCurrentTab}
            clickAbleTab
            substatus={subStatus}
            status={status}
            loanApplicationId={loanApplicationId}
            enabledInsurance={enabledInsurance}
            fieldAgent
            handleClose={handleClose}
            clickableTab={clickableTab}
          />
        )}
      </GridItem>
      <GridItem xs={12} sm={12} md={12} lg={12}>
        <Footer />
      </GridItem>
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </GridContainer>
  );
};

FieldAgentTabs.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(style)(FieldAgentTabs);